import { __rest } from "tslib";
import styled from '@emotion/styled';
import React from 'react';
import { Button } from '../button';
import { ProgressBar } from '../progress-bar';
const StyledWrapper = styled.div `
	display: flex;
	flex-direction: column;
	width: 100%;
	position: fixed;
	bottom: 0;
	background-color: white;
	padding-bottom: 1rem;
`;
const StyledProgressBar = styled(ProgressBar) `
	margin-bottom: 1rem;
`;
const StyledRow = styled.div `
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-bottom: 1rem;
	justify-content: space-between;
`;
const StyledButtonRow = styled(StyledRow) `
	padding: 0 1rem;
`;
export const ProgressStepper = (_a) => {
    var { sections, progress, setProgress, onNext, onPrev, variant = 'regular', nextLabel = 'Next', prevLabel = 'Back', className } = _a, props = __rest(_a, ["sections", "progress", "setProgress", "onNext", "onPrev", "variant", "nextLabel", "prevLabel", "className"]);
    const totalSteps = sections.reduce((steps, total) => total + steps, 0);
    const handleNext = () => {
        setProgress((currentProgress) => currentProgress < totalSteps ? currentProgress + 1 : currentProgress);
        if (onNext)
            return onNext();
    };
    const handlePrev = () => {
        setProgress((currentProgress) => currentProgress > 1 ? currentProgress - 1 : 0);
        if (onPrev)
            return onPrev();
    };
    return (React.createElement(StyledWrapper, Object.assign({}, props, { className: className }),
        React.createElement(StyledProgressBar, { className: className, sections: sections, progress: progress }),
        React.createElement(StyledButtonRow, null,
            prevLabel ? React.createElement(Button, { fill: "clear", text: prevLabel, onClick: handlePrev, "data-testid": "prev-btn", size: variant }) : React.createElement("div", null),
            React.createElement(Button, { text: nextLabel, onClick: handleNext, "data-testid": "next-btn", size: variant }))));
};
//# sourceMappingURL=ProgressStepper.js.map